import { useToggle } from "client/hooks/utils/useToggle";
import { setSort } from "store/features/bulkResize/actions";
import { bulkResizeSelector } from "store/features/bulkResize/selectors/bulkResizeSelector";
import { BulkResizeState } from "store/features/bulkResize/types";
import { useAppDispatch, useAppSelector } from "store/store";
import { Sort } from "store/types/sort";

export const useSort = () => {
    const { sort } = useAppSelector(bulkResizeSelector, equalityFn);
    const dispatch = useAppDispatch();
    const { isOpen, open, onClose: close } = useToggle();

    const handleClick = (value: Sort) => {
        close();
        dispatch(setSort(value));
    };

    return { isOpen, open, close, handleClick, sort };
};

const equalityFn = (left: BulkResizeState, right: BulkResizeState) => {
    if (left.sort !== right.sort) return false;

    return true;
};
